import { css } from '@emotion/css'
import { spacing, breakpoint, mediaQueryHelper } from '@offerzen/pinata-shame'

const styles = {
  row: css({
    display: 'flex',
    marginTop: spacing.default,
    flexDirection: 'column',
    alignItems: 'start',

    button: {
      marginTop: spacing.default,
      marginLeft: 0,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      alignItems: 'center',
      flexDirection: 'row',

      button: {
        marginTop: 0,
        marginLeft: spacing.default,
      },
    },
  }),

  explainerText: css({
    margin: 0,
  }),
}

export default styles
